
@if (iconName()) {
  <span [class]="'transport-list-card__line' + ' ' + iconName()"></span>
}